import React from 'react';
import { Button } from './ui/button';
import { Download, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ExportButton({ endpoint, filename, label, variant = "outline", size = "sm", className = "" }) {
  const [loading, setLoading] = React.useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/export/${endpoint}`, {
        responseType: 'blob',
      });
      
      const blob = new Blob([response.data]);
      
      // Create a temporary anchor element
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = downloadUrl;
      a.download = `${filename}_${new Date().toISOString().slice(0,10)}.xlsx`;
      
      // Append to body, click, and cleanup
      document.body.appendChild(a);
      a.click();
      
      // Cleanup after a short delay
      setTimeout(() => {
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
      }, 100);
      
    } catch (error) {
      console.error('Export error:', error);
      alert('فشل التصدير - Export failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleExport}
      disabled={loading}
      className={className}
      data-testid={`export-${endpoint}-btn`}
    >
      {loading ? (
        <Loader2 size={16} className="me-2 animate-spin" />
      ) : (
        <Download size={16} className="me-2" />
      )}
      {loading ? (label.includes('تصدير') ? 'جاري التصدير...' : 'Exporting...') : label}
    </Button>
  );
}
